import { Component, OnInit } from '@angular/core';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { BehaviorSubject, combineLatest, filter, map } from 'rxjs';
import { Enums } from 'constants/Enums.constant';
import { HAS_SHARED } from '@library/ui/directives/share/share.directive';
import { Share } from '@library/utils/interfaces/general-interfaces.interface';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { ConfigFacade } from '@library/store/config/config.facade';
import { WebAppConfigInterface } from '@store/config/webapp-config.interface';
import { FormControl } from '@angular/forms';
import { environment } from '@environments/environment';

interface WeathermapCardInterface{
  label: string,
  value: Module
}
@Component({
  selector: 'app-weathermap-card',
  templateUrl: './weathermap-card.component.html',
  styleUrls: ['./weathermap-card.component.scss'],
})
export class WeathermapCardComponent implements OnInit {

  constructor(
    private moduleFacade: ModulesFacade,
    private langPipe: LangPipe,
    private configFacade: ConfigFacade
  ) { }

  // Observable to determine if data has been shared via copy
  copied = new BehaviorSubject(false);
  copied$ = this.copied.asObservable();

  stations$ = this.moduleFacade.currentHomeModules$.pipe(
    isDefined(),
    map((modules: Module[]) => {
      const outdoorModules = modules.filter(module => module.type === Enums.ModuleType.NAMODULE1);
      const stations = outdoorModules.filter(station => {
        return modules.find(m => m.type === Enums.ModuleType.NAMAIN && m.id === station.bridge).public_ext_data;
      }).map(s => ({
        label: s.name,
        value: {...s }
      }));

      this.weatherControl.setValue(stations[0]);
      return stations;
    })
  );

  stationModalDisplay$ = new BehaviorSubject(false);
  weatherControl = new FormControl(null);

  viewModel$ = combineLatest([
    this.stations$,
    this.copied$,
    this.configFacade.config$
  ]).pipe(
    filter(([stations, copied, config]) => !!stations && !!config && copied !== null),
    map(([stations, hasCopied, config]: [WeathermapCardInterface[], boolean, WebAppConfigInterface]) => {
      return { stations, hasCopied, config };
    })
  );

  ngOnInit() {
    this.weatherControl.valueChanges.pipe(
      filter(v => !!v?.value),
      map(v => v.value)
    ).subscribe(() => {
      this.copied.next(false);
    });
  }

  hasCopied(event): void {
    if (event === HAS_SHARED.fallback) {
      this.copied.next(true);
    }
    else {
      this.copied.next(false);
    }
  }

  generateInvitation(station: WeathermapCardInterface, config: WebAppConfigInterface) {
    if(station){
      const url = config.weatherMapUrl + '/?stationid=' + station.value.bridge;
      const text = this.langPipe.transform(
        'station-settings.__COMMUNITY_SHARE_TEXT',
        [station.value.name, url]
      ).replace(/<br\/?>/g, '\n');

      return {
        text,
      } as Share;
    }
  }

  closeModal(stations: WeathermapCardInterface){
    this.stationModalDisplay$.next(false);
    this.copied.next(false);
    this.weatherControl.setValue(stations[0]);
  }

  openModal(event){
    event.stopPropagation();
    this.stationModalDisplay$.next(true);
  }

  copyLink(event){
    event.stopPropagation();
    this.copied.next(null);
  }

  openWeathermap(){
    return window.open(environment.weatherMapUrl);
  }

}
